/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ValidateAPIKeySecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type ValidateAPIKeyRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type ValidateAPIKeySecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ValidateAPIKeySecurity$outboundSchema: z.ZodMiniType<
  ValidateAPIKeySecurity$Outbound,
  ValidateAPIKeySecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function validateAPIKeySecurityToJSON(
  validateAPIKeySecurity: ValidateAPIKeySecurity,
): string {
  return JSON.stringify(
    ValidateAPIKeySecurity$outboundSchema.parse(validateAPIKeySecurity),
  );
}

/** @internal */
export type ValidateAPIKeyRequest$Outbound = {
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ValidateAPIKeyRequest$outboundSchema: z.ZodMiniType<
  ValidateAPIKeyRequest$Outbound,
  ValidateAPIKeyRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
    });
  }),
);

export function validateAPIKeyRequestToJSON(
  validateAPIKeyRequest: ValidateAPIKeyRequest,
): string {
  return JSON.stringify(
    ValidateAPIKeyRequest$outboundSchema.parse(validateAPIKeyRequest),
  );
}
